module.exports = __webpack_public_path__ + "img/1.9098f3c4.jpg";